(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2998],{

/***/ 22422:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...categoryUrl]]",
      function () {
        return __webpack_require__(17846);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _sy_app_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71346);
/* harmony import */ var _components_templates_BlogTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67825);
/* harmony import */ var _scenes_Blog_scenes_BlogOverview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82353);




var PostsGroup = function(param) {
    var category = param.category, posts = param.posts, user = param.user;
    (0,_sy_app_client__WEBPACK_IMPORTED_MODULE_1__/* .useLoadAnalytics */ .O3)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_BlogTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        activeCategory: category,
        user: user,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_scenes_Blog_scenes_BlogOverview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            posts: posts,
            category: category
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PostsGroup);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4668,5062,7052,3353,2296,7337,9842,7260,6863,3795,1346,9560,9774,2888,179], function() { return __webpack_exec__(22422); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);